/**************************************************
 * Nombre:       Tarjeta_Categoria_Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {contexData} from "../../App";
import {irArriba} from "../../Utilidades/irArriba";

const Tarjeta_Categoria_Footer = ({item, seleccionado, setSeleccionado}) => {
    const cData = useContext(contexData)
    const navigate = useNavigate()


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                onClick={() => setSeleccionado(item.nombre)}
                container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{
                        transition: 'all 0.2s ease-in-out',
                        background: theme.palette.primary.main,
                        color: 'white',
                        fontSize: 18,
                        fontWeight: 500,
                        cursor: 'pointer',
                        borderBottom: 2,
                        borderColor: '#ffffff00',
                        '&:hover': {
                            borderColor: '#fff',
                        }
                    }}
                >{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pl: 4}}>
                <Collapse in={seleccionado === item.nombre} sx={{width: '100%'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {item.subCat?.map((it, index) => {
                            return (
                                <Grid
                                    onClick={() => {
                                        navigate('/')
                                        cData.setSubCatEscogida(it.nombre)
                                        cData.setIconoCat(item.img)
                                        setTimeout(() => {
                                            irArriba()
                                        }, 500)
                                    }
                                    }
                                    container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0.5}}>
                                    <Typography
                                        sx={{
                                            transition: 'all 0.2s ease-in-out',
                                            color: 'white',
                                            fontSize: 14,
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            borderBottom: 2,
                                            borderColor: '#ffffff00',
                                            '&:hover': {
                                                borderColor: '#fff',
                                            }
                                        }}
                                    >{it.nombre}</Typography>
                                </Grid>

                            )
                        })}


                    </Grid>

                </Collapse>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Categoria_Footer